(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  /* Cache the shop's real money format (e.g. "{{amount}} EGP" or "LE {{amount}}"),
     read once from the section root's data-money-format attribute. Using the
     shop's actual format keeps prices the JS updates (on variant change)
     identical in style to the price Liquid renders on first load -- previously
     this used a generic Intl currency formatter that produced a different
     label ("EGP 400.00") than the shop's configured format ("LE 550.00"),
     making the sale price and the compare-at price look inconsistent. */
  var dvppMoneyFormatCache = null;
  function getMoneyFormat() {
    if (dvppMoneyFormatCache === null) {
      var rootEl = document.querySelector('[data-dvpp]');
      dvppMoneyFormatCache = (rootEl && rootEl.dataset.moneyFormat) || '{{amount}} EGP';
    }
    return dvppMoneyFormatCache;
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    var format = getMoneyFormat();
    var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!placeholder) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EGP';
      var locale = document.documentElement.lang || 'en';
      try {
        return amount.toLocaleString(locale, { style: 'currency', currency: currency });
      } catch (error) {
        return amount.toFixed(2) + ' ' + currency;
      }
    }

    var key = placeholder[1];
    var precision = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var value = amount.toFixed(precision);
    var parts = value.split('.');
    var useCommaDecimal = key.indexOf('comma_separator') > -1;
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, useCommaDecimal ? '.' : ',');
    value = useCommaDecimal ? parts.join(',') : parts.join('.');

    return format.replace(placeholder[0], value);
  }

  function updateCounts(cart) {
    var count = cart && cart.item_count;
    if (typeof count !== 'number') return;
    qsa('[data-cart-count],.cart-count-bubble,.cart-count,.header__cart-count,.site-header__cart-count').forEach(function (element) {
      element.textContent = count;
      element.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function openCart(cart) {
    if (window.DivaStableCart) {
      if (cart && typeof window.DivaStableCart.openWithCart === 'function') {
        window.DivaStableCart.openWithCart(cart);
        return;
      }
      if (typeof window.DivaStableCart.open === 'function') {
        window.DivaStableCart.open(cart || null);
        return;
      }
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart || null, bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { detail: cart || null, bubbles: true }));

    var trigger = qs('[data-cart-drawer-open],.js-cart-drawer-open,[data-drawer-options*="mini_cart"]');
    if (trigger) trigger.click();
  }

  function setStatus(root, message) {
    var status = qs('[data-dvpp-form-status]', root);
    if (!status) return;
    status.textContent = message || '';
    status.hidden = !message;
  }

  function initCountdown(root) {
    var element = qs('[data-dvpp-countdown]', root);
    if (!element || element.dataset.initialized === 'true') return;

    var end = Date.parse(element.dataset.end || '');
    if (!Number.isFinite(end)) {
      element.closest('.dvpp-deal').hidden = true;
      return;
    }

    element.dataset.initialized = 'true';
    var timer;

    function tick() {
      var difference = end - Date.now();
      if (difference <= 0) {
        element.textContent = '00:00:00';
        if (timer) window.clearInterval(timer);
        return;
      }
      var days = Math.floor(difference / 86400000);
      var hours = Math.floor((difference % 86400000) / 3600000);
      var minutes = Math.floor((difference % 3600000) / 60000);
      var seconds = Math.floor((difference % 60000) / 1000);
      element.textContent = (days ? days + 'd ' : '') + String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
    }

    tick();
    timer = window.setInterval(tick, 1000);
  }

  function updateStock(root, variant) {
    var element = qs('[data-dvpp-stock]', root);
    if (!element) return;

    if (!variant || variant.inventory_management !== 'shopify' || variant.inventory_policy === 'continue') {
      element.style.display = 'none';
      element.textContent = '';
      return;
    }

    var quantity = Number(variant.inventory_quantity);
    if (!Number.isFinite(quantity) || quantity <= 0) {
      element.style.display = 'none';
      element.textContent = '';
    } else if (quantity <= 3) {
      element.textContent = '🔴 باقي ' + quantity + ' قطعة فقط';
      element.className = 'dvpp-stock dvpp-stock--hot';
      element.style.display = 'flex';
    } else if (quantity <= 10) {
      element.textContent = '⚡ باقي ' + quantity + ' قطع';
      element.className = 'dvpp-stock dvpp-stock--low';
      element.style.display = 'flex';
    } else {
      element.style.display = 'none';
      element.textContent = '';
    }
  }

  function initSwipe(root) {
    var main = qs('.dvpp-main', root);
    if (!main) return;
    var startX = 0;
    var startY = 0;

    main.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });

    main.addEventListener('touchend', function (event) {
      var deltaX = event.changedTouches[0].clientX - startX;
      var deltaY = event.changedTouches[0].clientY - startY;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaY) > Math.abs(deltaX)) return;
      var thumbs = qsa('[data-dvpp-thumb]', root);
      var active = thumbs.findIndex(function (thumb) { return thumb.classList.contains('is-active'); });
      if (active < 0) active = 0;
      var next = deltaX < 0 ? active + 1 : active - 1;
      next = Math.max(0, Math.min(next, thumbs.length - 1));
      if (thumbs[next] && next !== active) thumbs[next].click();
    }, { passive: true });
  }

  function getFocusable(container) {
    return qsa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', container)
      .filter(function (element) { return element.offsetParent !== null; });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab') return;
    var focusable = getFocusable(container);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initZoom(root) {
    var mainImage = qs('[data-dvpp-main-img]', root);
    var zoomButton = qs('.dvpp-zoom', root);
    if (!mainImage || root.dataset.zoomInitialized === 'true') return;
    root.dataset.zoomInitialized = 'true';

    var lightbox = document.createElement('div');
    lightbox.className = 'dvpp-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', mainImage.alt || 'Product image');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = '<div class="dvpp-lb-bg"></div><div class="dvpp-lb-wrap" tabindex="-1"><img src="" alt=""><button type="button" class="dvpp-lb-close" aria-label="Close">&#x2715;</button></div>';
    document.body.appendChild(lightbox);

    var lightboxImage = qs('img', lightbox);
    var closeButton = qs('.dvpp-lb-close', lightbox);
    var returnFocus = null;

    function open() {
      returnFocus = document.activeElement;
      lightboxImage.src = (mainImage.currentSrc || mainImage.src || '').replace(/width=\d+/, 'width=1800');
      lightboxImage.alt = mainImage.alt || '';
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      closeButton.focus();
    }

    function close() {
      if (!lightbox.classList.contains('open')) return;
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
    }

    if (zoomButton) zoomButton.addEventListener('click', open);
    mainImage.style.cursor = 'zoom-in';
    mainImage.addEventListener('click', open);
    qs('.dvpp-lb-bg', lightbox).addEventListener('click', close);
    closeButton.addEventListener('click', close);
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else {
        trapTab(event, lightbox);
      }
    });
  }

  function initShare(root) {
    var button = qs('.dvpp-share', root);
    if (!button) return;
    button.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          var original = button.innerHTML;
          button.textContent = '✓';
          window.setTimeout(function () { button.innerHTML = original; }, 2000);
        });
      }
    });
  }

  function initStepper(root) {
    var minus = qs('.dvpp-step-minus', root);
    var plus = qs('.dvpp-step-plus', root);
    var input = qs('.dvpp-step-input', root);
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', function () {
      var value = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = Math.max(1, value - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', function () {
      var value = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = value + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    input.addEventListener('input', function () {
      var value = parseInt(input.value, 10);
      if (!Number.isFinite(value) || value < 1) input.value = 1;
    });
  }

  function syncDots(root, activeIndex) {
    qsa('.dvpp-dot', root).forEach(function (dot, index) {
      dot.classList.toggle('active', index === activeIndex);
      dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
    });
  }

  function parseResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        var message = data && (data.description || data.message);
        throw new Error(message || 'Unable to update the cart.');
      }
      return data;
    });
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(parseResponse);
  }

  function addToCart(root, form, button) {
    if (!form || form.dataset.submitting === 'true') return Promise.resolve();
    form.dataset.submitting = 'true';
    setStatus(root, '');

    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(parseResponse)
      .then(getCart)
      .then(function (cart) {
        updateCounts(cart);
        openCart(cart);
      })
      .catch(function (error) {
        setStatus(root, error.message || 'تعذرت إضافة المنتج. حاولي مرة أخرى.');
      })
      .finally(function () {
        form.dataset.submitting = 'false';
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          var variantAvailable = button.dataset.variantAvailable !== 'false';
          button.disabled = !variantAvailable;
        }
      });
  }

  function updateVariantUrl(variantId) {
    if (!window.history || !window.history.replaceState || !variantId) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({ variantId: variantId }, '', url.toString());
  }

  function initRoot(root) {
    if (!root || root.dataset.dvppInitialized === 'true') return;
    root.dataset.dvppInitialized = 'true';

    var variantsElement = qs('[data-dvpp-variants]', root);
    if (!variantsElement) return;

    var variants;
    try {
      variants = JSON.parse(variantsElement.textContent || '[]');
    } catch (error) {
      setStatus(root, 'تعذر تحميل اختيارات المنتج.');
      return;
    }

    var form = qs('form[action*="/cart/add"]', root);
    var idInput = form ? qs('input[name="id"]', form) : null;
    var priceElements = qsa('[data-dvpp-price]', root);
    var compareElement = qs('[data-dvpp-compare]', root);
    var saleElement = qs('[data-dvpp-sale]', root);
    var mainImage = qs('[data-dvpp-main-img]', root);
    var submit = qs('[data-dvpp-atc]', root);
    var stickyButtons = qsa('[data-dvpp-mobile-atc]', root);
    var stickyThumb = qs('#dvpp-sticky-thumb', root);
    var stickyLabel = qs('#dvpp-sticky-sel', root);

    qsa('[data-dvpp-thumb]', root).forEach(function (button, index) {
      button.addEventListener('click', function () {
        qsa('[data-dvpp-thumb]', root).forEach(function (item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        if (mainImage) {
          mainImage.removeAttribute('srcset');
          mainImage.src = button.dataset.full;
        }
        syncDots(root, index);
      });
    });

    qsa('.dvpp-dot', root).forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var thumbs = qsa('[data-dvpp-thumb]', root);
        if (thumbs[index]) thumbs[index].click();
      });
    });

    function selectedValues() {
      return qsa('[data-dvpp-option]', root).map(function (group) {
        var checked = qs('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      var selected = selectedValues();
      return variants.find(function (variant) {
        return selected.every(function (value, index) {
          return value !== null && variant.options[index] === value;
        });
      }) || null;
    }

    function sync() {
      var variant = findVariant();
      var available = Boolean(variant && variant.available);

      if (idInput) idInput.value = variant ? variant.id : '';
      priceElements.forEach(function (element) {
        element.textContent = variant ? money(variant.price) : '';
      });

      var discounted = Boolean(variant && variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price));
      if (compareElement) {
        compareElement.hidden = !discounted;
        compareElement.textContent = discounted ? money(variant.compare_at_price) : '';
      }
      if (saleElement) saleElement.hidden = !discounted;

      if (submit) {
        submit.dataset.variantAvailable = available ? 'true' : 'false';
        submit.disabled = !available;
        submit.textContent = available ? (submit.dataset.text || submit.textContent) : (submit.dataset.soldout || 'Sold out');
      }

      stickyButtons.forEach(function (button) {
        button.disabled = !available;
      });

      /* Only swap the main image (and its responsive srcset) when the
         selected variant actually changed. sync() also runs once on
         initial page load to reflect the pre-selected variant, which
         Liquid has already rendered correctly (including a matching
         srcset) -- re-swapping unconditionally here used to throw that
         server-rendered responsive image away on every page view and
         replace it with the variant's full, un-resized original photo. */
      if (variant && variant.featured_image && variant.featured_image.src && mainImage) {
        var currentVariantId = mainImage.dataset.currentVariantId ? Number(mainImage.dataset.currentVariantId) : null;
        if (currentVariantId !== Number(variant.id)) {
          mainImage.removeAttribute('srcset');
          mainImage.src = variant.featured_image.src;
          mainImage.dataset.currentVariantId = variant.id;
          if (stickyThumb) stickyThumb.src = variant.featured_image.src.replace(/width=\d+/, 'width=100');
        }
      }

      if (stickyLabel) {
        var selected = selectedValues().filter(Boolean);
        stickyLabel.textContent = selected.join(' · ');
        stickyLabel.style.display = selected.length ? 'inline-block' : 'none';
      }

      updateStock(root, variant);
      if (variant) updateVariantUrl(variant.id);
    }

    qsa('[data-dvpp-option] input', root).forEach(function (input) {
      input.addEventListener('change', sync);
    });
    sync();

    if (form) {
      form.addEventListener('submit', function (event) {
        if (event.submitter && event.submitter.name === 'checkout') return;
        event.preventDefault();
        addToCart(root, form, submit);
      });
    }

    stickyButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!form || button.disabled) return;
        var original = button.textContent;
        button.disabled = true;
        button.textContent = '⋯';
        addToCart(root, form, submit).finally(function () {
          button.textContent = original;
          var variant = findVariant();
          button.disabled = !(variant && variant.available);
        });
      });
    });

    initStepper(root);
    initSwipe(root);
    initZoom(root);
    initShare(root);
    initCountdown(root);

  }

  var sizeReturnFocus = null;

  function openSizeGuide(trigger) {
    var root = trigger.closest('[data-dvpp]');
    var modal = root && qs('[data-dvpp-modal]', root);
    if (!modal) return;
    sizeReturnFocus = trigger;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusTarget = qs('[data-dvpp-modal-close]', modal) || qs('.dvpp-modal-box', modal);
    if (focusTarget) focusTarget.focus();
  }

  function closeSizeGuide(modal) {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (sizeReturnFocus && typeof sizeReturnFocus.focus === 'function') sizeReturnFocus.focus();
    sizeReturnFocus = null;
  }

  document.addEventListener('click', function (event) {
    var sizeGuide = event.target.closest('[data-dvpp-sizeguide]');
    if (sizeGuide) {
      event.preventDefault();
      openSizeGuide(sizeGuide);
      return;
    }

    var close = event.target.closest('[data-dvpp-modal-close]');
    if (close) {
      event.preventDefault();
      closeSizeGuide(close.closest('[data-dvpp-modal]'));
      return;
    }

    if (event.target.matches('[data-dvpp-modal]')) {
      closeSizeGuide(event.target);
      return;
    }

    var add = event.target.closest('[data-dvpp-quick-add]');
    if (!add || add.disabled) return;
    event.preventDefault();
    add.disabled = true;
    add.setAttribute('aria-busy', 'true');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(add.dataset.variant), quantity: 1 })
    })
      .then(parseResponse)
      .then(getCart)
      .then(function (cart) {
        updateCounts(cart);
        openCart(cart);
      })
      .catch(function () {})
      .finally(function () {
        add.disabled = false;
        add.removeAttribute('aria-busy');
      });
  });

  document.addEventListener('keydown', function (event) {
    var modal = qs('[data-dvpp-modal].is-open');
    if (!modal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeSizeGuide(modal);
    } else {
      trapTab(event, modal);
    }
  });

  function initAll(scope) {
    qsa('[data-dvpp]', scope || document).forEach(initRoot);
  }

  initAll(document);
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });

  document.querySelectorAll('.dvpp-pc-img[data-hover]').forEach(function (image) {
    var original = image.src;
    var hover = image.dataset.hover;
    image.addEventListener('mouseenter', function () { image.src = hover; });
    image.addEventListener('mouseleave', function () { image.src = original; });
  });
})();
